// src/pages/clab-biodata-approved/components/FilterPanel.jsx
import React, { useState, useEffect } from 'react';
import Icon from 'components/AppIcon';
// import { biodataService } from 'utils/supabaseServices';
// TODO: Migrate biodataService usages to backend API

const FilterPanel = ({ filters, onFiltersChange }) => {
  const [isExpanded, setIsExpanded] = useState(false);
  const [recruiters, setRecruiters] = useState([]);
  const [nationalities, setNationalities] = useState([]);
  const [searchInput, setSearchInput] = useState(filters.search || '');
  const [skillInput, setSkillInput] = useState(filters.skill || '');

  useEffect(() => {
    const loadFilterOptions = async () => {
      try {
        // Get approved biodata to extract unique values
        // const biodataResult = await biodataService.getApprovedBiodata();
        
        if (/* biodataResult.data */ true) {
          // Extract unique nationalities
          const uniqueNationalities = [...new Set(/* biodataResult.data.map(b => b.nationality).filter(Boolean) */ [])];
          setNationalities(uniqueNationalities.sort());
          
          // Extract unique recruiters
          const uniqueRecruiters = /* biodataResult.data
            .map(b => b.recruiters)
            .filter(Boolean)
            .reduce((acc, recruiter) => {
              if (!acc.find(r => r.id === recruiter.id)) {
                acc.push(recruiter);
              }
              return acc;
            }, [])
            .sort((a, b) => a.agency_name.localeCompare(b.agency_name)) */ [];
          
          setRecruiters(uniqueRecruiters);
        }
      } catch (error) {
        console.error('Failed to load filter options:', error);
      }
    };

    loadFilterOptions();
  }, []);

  useEffect(() => {
    setSearchInput(filters.search || '');
    setSkillInput(filters.skill || '');
  }, [filters.search, filters.skill]);

  useEffect(() => {
    if (searchInput === (filters.search || '')) return;
    const handle = setTimeout(() => {
      // Double-check before calling to prevent loops
      if (searchInput === (filters.search || '')) return;
      onFiltersChange({
        ...filters,
        search: searchInput
      });
    }, 500);
    return () => clearTimeout(handle);
  }, [searchInput]);

  useEffect(() => {
    if (skillInput === (filters.skill || '')) return;
    const handle = setTimeout(() => {
      // Double-check before calling to prevent loops
      if (skillInput === (filters.skill || '')) return;
      onFiltersChange({
        ...filters,
        skill: skillInput
      });
    }, 500);
    return () => clearTimeout(handle);
  }, [skillInput]);

  const handleFilterChange = (key, value) => {
    onFiltersChange({
      ...filters,
      [key]: value
    });
  };

  const clearFilters = () => {
    setSearchInput('');
    setSkillInput('');
    onFiltersChange({
      search: '',
      nationality: '',
      recruiter_id: '',
      date_from: '',
      date_to: '',
      skill: ''
    });
  };

  const hasActiveFilters = Object.values(filters).some(value => value !== '');

  return (
    <div className="card">
      <div className="p-4">
        <div className="flex items-center justify-between">
          <div className="flex items-center space-x-3">
            <Icon name="Filter" size={20} className="text-secondary-600" />
            <h3 className="text-lg font-semibold text-text-primary">Filters</h3>
            {hasActiveFilters && (
              <span className="px-2 py-1 bg-primary-100 text-primary-700 rounded-full text-xs font-medium">
                Active
              </span>
            )}
          </div>
          <div className="flex items-center space-x-2">
            {hasActiveFilters && (
              <button
                onClick={clearFilters}
                className="flex items-center space-x-1 px-3 py-1 text-sm text-secondary-600 hover:text-secondary-800 font-medium"
              >
                <Icon name="X" size={14} />
                <span>Clear</span>
              </button>
            )}
            <button
              onClick={() => setIsExpanded(!isExpanded)}
              className="p-2 text-secondary-600 hover:bg-secondary-100 rounded-md transition-colors duration-150"
            >
              <Icon name={isExpanded ? 'ChevronUp' : 'ChevronDown'} size={16} />
            </button>
          </div>
        </div>

        {/* Quick Search - Always Visible */}
        <div className="mt-4">
          <div className="relative">
            <Icon name="Search" size={16} className="absolute left-3 top-1/2 transform -translate-y-1/2 text-secondary-400" />
            <input
              type="text"
              placeholder="Search by name, passport... (Press Enter or wait 0.5s)"
              value={searchInput}
              onChange={(e) => setSearchInput(e.target.value)}
              onKeyDown={(e) => {
                if (e.key === 'Enter') {
                  onFiltersChange({
                    ...filters,
                    search: searchInput
                  });
                }
              }}
              className="w-full pl-10 pr-4 py-2 border border-secondary-300 rounded-md focus:ring-primary focus:border-primary"
            />
          </div>
        </div>

        {/* Advanced Filters - Collapsible */}
        {isExpanded && (
          <div className="mt-6 pt-4 border-t border-secondary-200">
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
              <div>
                <label className="block text-sm font-medium text-text-secondary mb-2">
                  Nationality
                </label>
                <select
                  value={filters.nationality}
                  onChange={(e) => handleFilterChange('nationality', e.target.value)}
                  className="input-field w-full"
                >
                  <option value="">All Nationalities</option>
                  {nationalities.map((nationality) => (
                    <option key={nationality} value={nationality}>
                      {nationality}
                    </option>
                  ))}
                </select>
              </div>

              <div>
                <label className="block text-sm font-medium text-text-secondary mb-2">
                  Skill keyword
                </label>
                <input
                  type="text"
                  value={skillInput}
                  onChange={(e) => setSkillInput(e.target.value)}
                  onKeyDown={(e) => {
                    if (e.key === 'Enter') {
                      onFiltersChange({
                        ...filters,
                        skill: skillInput
                      });
                    }
                  }}
                  placeholder="e.g. welding, scaffolding (Press Enter or wait 0.5s)"
                  className="input-field w-full"
                />
              </div>

              <div>
                <label className="block text-sm font-medium text-text-secondary mb-2">
                  Recruiter
                </label>
                <select
                  value={filters.recruiter_id}
                  onChange={(e) => handleFilterChange('recruiter_id', e.target.value)}
                  className="input-field w-full"
                >
                  <option value="">All Recruiters</option>
                  {recruiters.map((recruiter) => (
                    <option key={recruiter.id} value={recruiter.id}>
                      {recruiter.agency_name}
                    </option>
                  ))}
                </select>
              </div>

              <div>
                <label className="block text-sm font-medium text-text-secondary mb-2">
                  Approved From
                </label>
                <input
                  type="date"
                  value={filters.date_from}
                  onChange={(e) => handleFilterChange('date_from', e.target.value)}
                  className="input-field w-full"
                />
              </div>

              <div>
                <label className="block text-sm font-medium text-text-secondary mb-2">
                  Approved To
                </label>
                <input
                  type="date"
                  value={filters.date_to}
                  onChange={(e) => handleFilterChange('date_to', e.target.value)}
                  className="input-field w-full"
                />
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default FilterPanel;
